<template>
    <div>
        <template v-if="UIConcern === 'Checkbox'">
            <a-checkbox
                v-for="(item, idx) in items"
                :key="idx"
                :checked="items[idx].checked === true || valuesMap[fieldName][idx].checked === true"
                @change="e => change(idx, e, 'check', meta)"
            >
                {{ item.attributeName }}
            </a-checkbox>
        </template>
        <template v-else-if="UIConcern === 'Select'">
            <multiselect
                :options="options"
                :multiple="true"
                :value="valuesMap[fieldName]"
                @input="e => change(null, e, 'select', meta)"
                label="label"
                trackBy="value"
                :hide-selected="true"
                :searchable="true"
                :close-on-select="false"
            >
            </multiselect>
        </template>
        <template v-else-if="UIConcern === 'Radio'">
            <a-radio-group
                :value="valuesMap[fieldName]">
                <a-radio
                    v-for="(item, index) in items"
                    :key="index"
                    :value="item.attributeName"
                    @click="e => change(null, item.attributeName, 'radio', meta)"
                    >{{ item.attributeName }}</a-radio>
            </a-radio-group>
        </template>
        <template v-else-if="UIConcern === 'Object'">
            <div>
                <b-row
                    v-for="(obj, outIdx) in valuesMap[fieldName]"
                    :key="outIdx"
                    >
                    <card :classes="{ root: 'rel' }">
                    <b-row>
                        <b-col md="6" v-for="(item, idx) in items" :key="idx">
                            <b-row>
                                <b-col md="4">
                                    <div class="label">
                                        {{ item.attributeName }}
                                    </div>
                                </b-col>
                                <b-col md="8">
                                    <a-input
                                        :type="cast(item.attributeValueType)"
                                        class="mt-2"
                                        :value="obj[item.attributeName]"
                                        @change="changeArrayObject({
                                            index: outIdx,
                                            type: item.attributeValueType,
                                            meta: meta,
                                            arrObj: true,
                                            action: 'change',
                                            e: $event.target.value,
                                            fieldName: item.attributeName
                                        })"
                                    />
                                </b-col>
                            </b-row>
                        </b-col>
                        </b-row>
                        <i
                            class="fa fa-close left-top"
                            @click="changeArrayObject({
                                index: outIdx,
                                meta: meta,
                                arrObj: true,
                                action: 'remove'
                            })"
                            ></i>
                    </card>
                </b-row>
                <b-button
                    class="mr-1 btn-brand"
                    variant="facebook"
                    @click="changeArrayObject({
                        meta: meta,
                        arrObj: true,
                        action: 'add',
                        fieldName: fieldName
                    })">
                    <i class="fa fa-plus"></i>
                    <span>Add</span>
                </b-button>
            </div>
        </template>
    </div>
</template>

<style scoped>
    .label{
        margin: 10px 0px 0 0;
    }
    .row{
        margin: 0;
    }
    .address{
        border: 1px solid #ccc;
        margin: 10px 0;
        border-radius: 4px;
        padding: 5px 5px 10px 0;
    }
    .rel{
        position: relative;
    }
    .left-top{
        position: absolute;
        top: 3px;
        right: 4px;
        color: red;
        font-size: 16px;
        cursor: pointer;
    }
</style>

<script>
import vSelect from 'vue-select'
import Field from "./Field"
import Card from '../Generics/Card.vue'
import 'vue-select/dist/vue-select.css'
export default {
    props: {
        fieldName: {
            type: String
        },
        items: {
            type: Array,
            required: true
        },
        UIConcern: {
            type: String,
            required: true
        },
        meta: {
            type: Array
        },
        valuesMap: {
            type: Object
        }
    },
    methods: {
        changeArrayObject(data) {
            this.$emit('change', data)
        },
        change(idx, e, type, meta){
            console.log('changed meta : ', meta)
            this.$emit('change', {
                index: idx,
                e, type, meta,
                fieldName: this.$props.fieldName
            })
        },
        cast: function(type){
            let mapping = {
                'String': 'text',
                'Number': 'number'
            }
            return mapping[type]
        }
    },
    computed: {
        options: function(){
            return this.items ? this.items.map(i => ({ label: i.attributeName, value: i._id })) : []
        }
    },
    directives: {
        tabindex: {
            inserted(el) {
            el.setAttribute('tabindex', 0);
            }
        }
    },
    components: {
        vSelect,
        'field': Field,
        'card': Card
    }
}
</script>
